import { Space, Typography } from 'antd';
import React from 'react';
import styles from './LandingLayout.module.css';
import LandingHeader from 'src/components/Header/LandingHeader/LandingHeader';

const { Text } = Typography;

interface Props {
  children: React.ReactNode;
}

const LandingLayout = (props: Props) => {
  const { children } = props;

  return (
    <Space className={styles.LandingLayout}>
      <LandingHeader />
      <Space className={styles['LandingLayout--Wrapper']}>{children}</Space>
      <div
        className="flex justify-center align-center"
        style={{ backgroundColor: '#263238', height: 50, width: '100%', zIndex: 2 }}
      >
        <Text className={styles['LandingLayout--Footer']}>
          Data Copyright &copy; Jaguar Land Rover {new Date().getFullYear()}. All rights reserved.
        </Text>
      </div>
    </Space>
  );
};

export default LandingLayout;
